import { PromosCommentsWidget } from './promos-comments';
import { PromosShareWidget } from './share-widget/promos-share-widget';
import { PromosPrintWidget } from './promos-print-widget';
import { PromosEmailAlertsWidget as EmailAlertsWidget } from './promos-email-alerts';
import { CommentsWidgetApi } from 'www/modules/comments/widget/comments-widget-api';

let commentsWidgetApi = null;

export class PromosToolbar{
	constructor(el){
		this.el = el;
		this.WidgetsMap = new Map();
	}

	init(){
		this.initComments();
		this.initShare();
		this.initPrint();
		$(document).ready(()=>{
			this.initEmailAlerts();
		})
	}

	initComments(){	
		if (typeof(window.vfUuid) === 'undefined') {
			return;
		}
		if(commentsWidgetApi==null){
			commentsWidgetApi = new CommentsWidgetApi();
		}
		let commentsWidget = new PromosCommentsWidget(commentsWidgetApi);
		
		this.el.appendChild(commentsWidget.el);
		commentsWidget.init();
		
		commentsWidget.onClick.subscribe( e => {
			window.initComments();
		})
		this.WidgetsMap.set("comments",commentsWidget);
	}
	initEmailAlerts(){
		if (typeof window.conceptId !== "undefined" || typeof window.sectionId !== "undefined") {
			let emailAlertsWidget = new EmailAlertsWidget();
			this.el.appendChild(emailAlertsWidget.el);
			emailAlertsWidget.init();
			this.WidgetsMap.set("email-alerts",emailAlertsWidget);
		}
	}
	initPrint(){
		if(Medscape.isMobile){
			return;
		}
		let printWidget = new PromosPrintWidget();
		this.el.appendChild(printWidget.el);
		printWidget.init();
		this.WidgetsMap.set("print",printWidget);
	}
	initShare(){
		let shareWidget = new PromosShareWidget();
		this.el.appendChild(shareWidget.el);
		shareWidget.init();
		this.WidgetsMap.set("share",shareWidget);
	}
}

